import { defineNuxtPlugin } from 'nuxt/app'

/**
 * 处理 OAuth provider 回到业务页面后的 code、cookie 或未注册身份参数。
 */
export default defineNuxtPlugin({
  name: 'third-party-callback',
  dependsOn: ['shared-app-store', 'app-request-context'],
  async setup() {
    const route = useRoute()

    const hasThirdPartyIdentityCallback =
      Boolean(route.query.id || route.query.openId || route.query.openid || route.query.userId) &&
      Boolean(route.query.returnurl || route.query.from || route.query.fromurl)
    const hasThirdPartyCallback =
      route.query.type === 'login' ||
      Boolean(route.query.cookieValue || route.query.cookievalue || route.query.code || route.query.thirdpayload) ||
      hasThirdPartyIdentityCallback

    if (!hasThirdPartyCallback) {
      return
    }

    await useThirdPartyCallback().processThirdPartyCallback()
  },
})
